import SpotlightConstants from '@/utils/enums/spotlightConstants';

const LowMileage = () => import('@/modules/spotlight/components/categories/highlights/LowMileage.vue');
const VehicleComparison = () => import('@/modules/spotlight/components/categories/highlights/VehicleComparison.vue');
const RecentPriceDrop = () => import('@/modules/spotlight/components/categories/highlights/RecentPriceDrop.vue');
const NewListing = () => import('@/modules/spotlight/components/categories/highlights/NewListing.vue');
const HighSafetyRating = () => import('@/modules/spotlight/components/categories/highlights/HighSafetyRating.vue');
const SiriusXMIntro = () => import('@/modules/spotlight/components/categories/highlights/HighlightsSiriusXM.vue');
const GettingNoticed = () => import('@/modules/spotlight/components/categories/highlights/GettingNoticed.vue');
const GreatDeal = () => import('@/modules/spotlight/components/categories/highlights/GreatDeal.vue');

export default [
  {
    path: SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM'],
    component: SiriusXMIntro,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['LOW-MILEAGE'],
    component: LowMileage,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['VEHICLE-COMPARISON'],
    component: VehicleComparison,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['PRICE-REDUCTION'],
    component: RecentPriceDrop,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['NEW-LISTING'],
    component: NewListing,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['HIGH-SAFETY-RATING'],
    component: HighSafetyRating,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['GETTING-NOTICED'],
    component: GettingNoticed,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: SpotlightConstants.internalNames.autoverify['GREAT-DEAL'],
    component: GreatDeal,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
    },
  },
  {
    path: 'error',
    redirect: '../../error',
  },
].map(route => {
  const newRoute = { ...route };
  newRoute.meta = {
    ...newRoute.meta,
    productInformationPage: true,
    category: SpotlightConstants.categories.HIGHLIGHTS,
    headerStyleClasses: 'mb-0',
  };
  return newRoute;
});
